import { render, staticRenderFns } from "./visceraData.vue?vue&type=template&id=058f00ea&scoped=true"
import script from "./visceraData.vue?vue&type=script&lang=js"
export * from "./visceraData.vue?vue&type=script&lang=js"
import style0 from "./visceraData.vue?vue&type=style&index=0&id=058f00ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.31_cache-loader@4.1.0_webpack@4.47.0__css-load_96f0868f9f114531bdcfa48c322cb453/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058f00ea",
  null
  
)

export default component.exports